/**
 * Meting van de verlanglijst — de reden dat fase 0 bestaat.
 *
 * Zelfde patroon als free-gifts.js (SHO-9521): custom events naar de Shopify
 * Web Pixels via `Shopify.analytics.publish`. Die staat vaak pas ná de
 * theme-modules klaar, dus we wachten er kort op met een wachtrij. Meten mag
 * winkelen nooit breken: alles zit in een try/catch en faalt stil.
 *
 * Events:
 *   hds:wishlist_add      — hartje aan   { variant_id, handle, price, count, template }
 *   hds:wishlist_remove   — hartje uit   { variant_id, count, template }
 *   hds:wishlist_view     — verlanglijstpagina bekeken { count, total }
 *   hds:wishlist_cart     — vanaf de lijst in de winkelwagen { items, total }
 */

import { WISHLIST_CHANGE } from '@theme/wishlist-store';
import { whenPageActive } from '@theme/hds-page-activation';

const DEADLINE_MS = 8000;
const RETRY_MS = 250;

export function publishWishlistEvent(name, payload) {
  if (document.prerendering) {
    whenPageActive(() => publishWishlistEvent(name, payload));
    return;
  }
  const deadline = Date.now() + DEADLINE_MS;

  const tick = () => {
    try {
      const publish = window.Shopify?.analytics?.publish;
      if (typeof publish === 'function') {
        publish(name, payload);
        return;
      }
    } catch {
      return; // meten mag nooit een klik breken
    }
    if (Date.now() < deadline) setTimeout(tick, RETRY_MS);
  };

  tick();
}

const template = () => {
  try {
    return (typeof Theme !== 'undefined' ? Theme : globalThis.Theme)?.template?.name ?? '';
  } catch {
    return '';
  }
};

document.addEventListener(WISHLIST_CHANGE, (event) => {
  const { change, state, origin } = event.detail ?? {};
  if (!change || origin !== 'local') return; // niet meten wat een ander tabblad deed

  publishWishlistEvent(change.added ? 'hds:wishlist_add' : 'hds:wishlist_remove', {
    variant_id: change.id,
    handle: change.handle ?? '',
    price: change.price ?? 0,
    count: state.items.length,
    template: template(),
  });
});
